var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('div',{staticClass:"gray-box"},[_c('div',{staticClass:"floor"},[_c('img',{attrs:{"src":_vm.t_data.config.imgUrl,"alt":""}})])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }